export default "__VITE_ASSET__cJ9SMyaE__"